import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageSyncService {

  private syncKey = 'session-storage-sync';

  constructor() {
    // Listen for storage events
    window.addEventListener('storage', this.syncSessionStorage.bind(this));
  }

  exportSessionStorage(): void {
    const sessionStorageData: { [key: string]: string } = {};
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key) {
        sessionStorageData[key] = sessionStorage.getItem(key) as string;
      }
    }
    localStorage.setItem(this.syncKey, JSON.stringify(sessionStorageData));
  }

  importSessionStorage(data: string): void {
    const sessionStorageData = JSON.parse(data);
    for (const key in sessionStorageData) {
      sessionStorage.setItem(key, sessionStorageData[key]);
    }
  }

  syncSessionStorage(event: StorageEvent): void {
    if (event.key === this.syncKey && event.newValue) {
      this.importSessionStorage(event.newValue);
    }
  }

  GetSyncKey(){
    return localStorage.getItem(this.syncKey);
  }
}
